// extracted by mini-css-extract-plugin
export default {"sectionPadding":"EditFormStyles_sectionPadding__HyvKY","titlePadding":"EditFormStyles_titlePadding__1mGzW"};